import React from 'react'
import {Router, Route, IndexRoute } from 'react-router'
import About from './containers/About'
import App from './components/App';
import Donate from './components/Donate/Donate'
import GetInvolved from './components/GetInvolved/GetInvolved'
import Home from './components/Home/Home'
import Material from './components/Materials/Material'
import Materials from './components/Materials/Materials'
import OurVoice from './components/OurVoice/OurVoice'
import Outreach from './containers/Outreach'
import OutreachDetail from './containers/OutreachDetail'
import materialsConfig from './configs/materials-config'


const Routes = (props) => (
  <Router {...props} onUpdate={() => window.scrollTo(0, 0)}>
    <Route path='/' component={App}>
      <IndexRoute component={Home} />
      <Route path='/about' component={About} />
      <Route path='/about/:value' component={About} />
      <Route path='/materials' component={Materials} />
      <Route path="/materials/:key" component={Material} data={materialsConfig} />
      <Route path='/outreach' component={Outreach} />
      <Route path='/outreach/:value' component={OutreachDetail} />
      <Route path='/our-voice' component={OurVoice} />
      <Route path='/get-involved' component={GetInvolved} history={props.history}>
        <Route path='/get-involved/:value' component={GetInvolved} />
        <Route path='/get-involved/:value/:job' component={GetInvolved} />
      </Route>
      <Route path='/donate' component={Donate} />
    </Route>
  </Router>
)

export default Routes


// WEBPACK FOOTER //
// ./src/routes.js